import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import { PiCoins } from "react-icons/pi";
import { FiDownload } from "react-icons/fi";
import ProtectedCanvasImage from "../../components/ProtectedCanvasImage";

const Download = () => {
  const navigate = useNavigate();

  const [categories, setCategories] =
    useState([]);

  const [
    selectedCategory,
    setSelectedCategory,
  ] = useState(null);

  const [products, setProducts] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [
    productLoading,
    setProductLoading,
  ] = useState(false);

  const [error, setError] =
    useState("");

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(
      date
    ).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const fetchDownloadedProducts =
    async () => {
      try {
        setLoading(true);
        setError("");

        const response =
          await api.get(
            "/customerProfileRoutes/customer/downloaded-products-by-category"
          );

        const categoryData =
          response?.data?.data || [];

        setCategories(
          categoryData
        );

        if (
          categoryData.length > 0
        ) {
          setSelectedCategory(
            categoryData[0]
          );

          setProducts(
            categoryData[0]
              ?.products || []
          );
        } else {
          setSelectedCategory(
            null
          );

          setProducts([]);
        }
      } catch (err) {
        console.error(
          "Download fetch error:",
          err
        );

        setError(
          err?.response?.data
            ?.message ||
            "Failed to fetch downloaded products"
        );
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchDownloadedProducts();
  }, []);

  const handleCategoryClick = (
    category
  ) => {
    setProductLoading(true);

    setSelectedCategory(
      category
    );

    setProducts(
      category?.products || []
    );

    setTimeout(() => {
      setProductLoading(false);
    }, 150);
  };

  return (
    <>
      <Row className="mx-0 breadcrumb_part">
        <Col
          md={12}
          lg={12}
          xs={12}
          className="prof_title mb-4"
        >
          <h4>Downloads</h4>
        </Col>
      </Row>

      <Row className="mx-0 p-0">
        <Col
          md={12}
          lg={12}
          xs={12}
          className="mb-4 padding-0"
        >
          <div className="choosecate">
            {loading ? (
              <div className="py-3 text-center">
                <Spinner
                  animation="border"
                  size="sm"
                />
              </div>
            ) : error ? (
              <div className="text-danger small py-2">
                {error}
              </div>
            ) : categories.length ===
              0 ? (
              <div className="small text-muted py-2">
                No downloaded
                categories found
              </div>
            ) : (
              <ul className="mb-0 ps-0">
                {categories.map(
                  (category) => (
                    <li
                      key={
                        category.category_id ||
                        category.category_name
                      }
                      onClick={() =>
                        handleCategoryClick(
                          category
                        )
                      }
                      style={{
                        background:
                          selectedCategory
                            ?.category_name ===
                          category.category_name
                            ? "#00665b"
                            : "transparent",

                        fontWeight:
                          "400",
                      }}
                    >
                      {category?.category_image_url ? (
                        <img
                          src={
                            category.category_image_url
                          }
                          alt={
                            category.category_name
                          }
                        />
                      ) : null}

                      <p>
                        {
                          category.category_name
                        }

                        <small className="d-block" />
                      </p>
                    </li>
                  )
                )}
              </ul>
            )}
          </div>
        </Col>

        <Col
          md={12}
          lg={12}
          xs={12}
          className="padding-0"
        >
          <div className="allempList">
            {loading ? (
              <div className="py-4 text-center">
                <Spinner animation="border" />
              </div>
            ) : productLoading ? (
              <div className="py-4 text-center">
                <Spinner
                  animation="border"
                  size="sm"
                />
              </div>
            ) : !selectedCategory ? (
              <div className="small text-muted py-3">
                No category selected
              </div>
            ) : products.length ===
              0 ? (
              <div className="small text-muted py-3">
                No products found in
                this category
              </div>
            ) : (
              <ul className="gap-3">
                {products.map(
                  (product) => (
                    <li
                      key={
                        product.product_id
                      }
                      className="position-relative"
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/product_details/${product.product_id}`
                          )
                        }
                      >
                        <div
                          style={{
                            overflow:
                              "hidden",
                          }}
                        >
                          {product
                            ?.thumbnail
                            ?.image_url ? (
                            <ProtectedCanvasImage
                              src={
                                product
                                  .thumbnail
                                  .image_url
                              }
                              alt={
                                product.product_name
                              }
                              width="100%"
                              height={220}
                              objectFit="cover"
                              objectPosition="top center"
                              onClick={() =>
                                navigate(
                                  `/product_details/${product.product_id}`
                                )
                              }
                            />
                          ) : (
                            <div className="text-muted small">
                              No Thumbnail
                            </div>
                          )}
                        </div>

                        <Card.Body className="p-0">
                          <div className="product-title position-relative">
                            <p>
                              {
                                product.product_name
                              }
                            </p>

                            <div className="coinpart">
                              <span
                                className="text-pink iconprice"
                                style={{
                                  fontSize:
                                    "16px",
                                }}
                              >
                                <PiCoins />{" "}
                                {product.coins_spent ??
                                  0}
                              </span>
                            </div>
                          </div>

                          <div className="productDET">
                            <span>
                              <FiDownload />{" "}
                              {formatDate(
                                product.downloaded_at
                              )}
                            </span>
                          </div>
                        </Card.Body>
                      </div>
                    </li>
                  )
                )}
              </ul>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Download;